/* eslint-disable */
import React from "react"

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Legend } from "chart.js"
import { Line } from "react-chartjs-2"
import ZoomPlugin from "chartjs-plugin-zoom"

import useAudioContext from '../../utils/eSteth/AudioState'

import options from "../../utils/eSteth/lineOptions"

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Legend, ZoomPlugin)

const AudioChart = ({ chartRef }) => {
	const { audio, samples } = useAudioContext()

	const data = {
		labels: samples?.t || [],
		datasets: [
			{
				data: samples?.v || null,
				borderColor: "rgb(255, 99, 132)",
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				borderWidth: 0.5,
			},
		],
	}

	if (!audio) return <></>

	return <Line ref={chartRef} options={options} data={data} />
}

export default AudioChart

